<template>
    <div>

        <v-text-field tile outlined dense hide-details="auto"
        v-model="pedido" 
        placeholder="Ingresa tu factura con letra y números sin espacios"
        style="border-radius: 0px!important; background-color:white;"
        :error-messages="pedidoErrors"
        @keydown.space.prevent
        @paste.prevent
        ></v-text-field>

        <v-btn  block dark tile 
        elevation="0" 
        class="button font-weight-bold"
        color="red darken-4"
        @click="buscarPedido()"
        >Buscar</v-btn>

    </div>
</template>

<script>

    //Libraries
    import { required, minLength, maxLength} from 'vuelidate/lib/validators'

    import formValidations from '../validations/FormValidations' 

    import router from '../../../router'

export default {
    props: {

    },
    data() {
        return {
            pedido: '',
        }
    },
    validations: {
        pedido:{required,minLength: minLength(1), maxLength: maxLength(12)}
    },
    methods: {
        buscarPedido: function () {
            if(this.checkForm()) { return }
            //router.push({ name:'About' })
            router.push({ name:'Pedido',params: { pedido: this.pedido.trim() } })
        },
        checkForm: function() {
            this.$v.$touch()
            return this.$v.$invalid
        },
    },
    computed: {
        pedidoErrors () {
            return formValidations.pedidoValidations(this.$v.pedido)
        },
    }
}
</script>

<style>

</style>